export const DEFAULT_VIEWPORT = {
  latitude: 39.546,
  longitude: -97.852,
  zoom: 3,
}
